<template>
  <div
    class="themeCard"
    :class="{absolutePosition: absolutePosition, complete: completed, inProgress: inProgress, empty: empty, button: addThemeBtn}"
    v-bind:style="{ top: topPos + 'px', left: leftPos + 'px' }"
    :id="tcId"
  >
    <div class="leftShape" :id="tcId+'_LS'"></div>
    <div class="rightShape" :id="tcId+'_RS'"></div>

    <div class="themeCardHeader" :class="{'abbr': theme.abbreviation, 'addIcon': !theme.abbreviation}">
      <span v-if="theme.abbreviation">{{theme.abbreviation}}</span>
      <plus-icon v-else title />
    </div>

    <p class="content" :title="shortenedTitle!=theme.title ? theme.title : ''">{{shortenedTitle}}</p>

    <span
      v-if="completed || inProgress"
      class="picto"
      :class="{completedIcon: completed, inProgressIcon: inProgress}"
      :title="themeStatusTitle"
    >
      <check-icon v-if="completed" title />
      <dots-horizontal-icon v-if="inProgress" title />
    </span>
  </div>
</template>

<script>
import PlusIcon from "vue-material-design-icons/Plus.vue";
import CheckIcon from "vue-material-design-icons/Check.vue";
import DotsHorizontalIcon from "vue-material-design-icons/DotsHorizontal.vue";

export default {
  name: "ThemeCard",
  components: {
    PlusIcon,
    CheckIcon,
    DotsHorizontalIcon
  },
  props: {
    theme: Object,
    index: Number,
    leftPos: Number,
    topPos: Number,
    displayRosace: Boolean
  },
  computed: {
    tcId: function() {
      return "TC_" + this.theme.ref;
    },
    shortenedTitle: function() {
      const maxLength = 95;
      if (this.theme.title.length > maxLength) {
        return this.theme.title.substring(0, maxLength - 1) + "…";
      }
      return this.theme.title;
    },
    absolutePosition: function() {
      return this.displayRosace;
    }
  },
  data: function() {
    return {
      addThemeBtn: false, // permet de traiter le design spécifique lié au bouton ajout d'un thème
      completed: false,
      inProgress: false,
      empty: false,
      themeStatusTitle: null
    };
  },
  created: function() {
    if (this.theme.addThemeBtn) {
      this.addThemeBtn = true;
    }
    else {
      // Calcul du statut du thème
      this.computeThemeStatus();
    }
  },
  mounted: function() {
    let outerDiameter = 155,
      outerRadius = outerDiameter / 2;
    let innerPadding = 3;
    let innerDiameter = outerDiameter - 2 * innerPadding,
      innerRadius = innerDiameter / 2;
    let nbSteps = 15;
    let stepA = Math.PI / (nbSteps - 1);

    let pathLeft = "polygon(0px 0px, " + outerRadius + "px 0px, ";
    let pathRight = "polygon(" + outerRadius + "px 0px, 0px 0px, ";

    for (let i = 0; i < nbSteps; i++) {
      let a = stepA * i;
      let x = Math.round((1 - Math.sin(a)) * innerRadius) + innerPadding;
      let y = Math.round((1 - Math.cos(a)) * innerRadius) + innerPadding;
      pathLeft += x + "px " + y + "px, ";
      pathRight += outerRadius - x + "px " + y + "px, ";
    }
    pathLeft +=
      outerRadius + "px " + outerDiameter + "px, 0px " + outerDiameter + "px)";
    pathRight +=
      "0px " +
      outerDiameter +
      "px, " +
      outerRadius +
      "px " +
      outerDiameter +
      "px)";

    $("#" + this.tcId + "_LS") //eslint-disable-line no-undef
      .css("shape-outside", pathLeft)
      .css("clip-path", pathLeft); 
    $("#" + this.tcId + "_RS") //eslint-disable-line no-undef
      .css("shape-outside", pathRight)
      .css("clip-path", pathRight);
  },
  methods: {
    computeThemeStatus: function() {
      //console.log("ThemeCard.computeThemeStatus", this.theme);

      // On réinitialise tous les flags à false et le status à null
      this.completed = false;
      this.inProgress = false;
      this.empty = false;
      this.themeStatusTitle = null;

      // Variable utilisée pour que le code ci-après soit le plus similaire possible à celui de la méthode setStatus(context, theme) de gpsstModule.js
      var theme = this.theme; 

      var nbSubThemes = theme.subThemes ? theme.subThemes.length : 0;
     
      // On compte le nb de sous-thèmes évalués (= notés ou N/A)
      var ratingDone = 0;
      for (let l = 0; l < nbSubThemes; l++) {
        var subTheme = theme.subThemes[l];
        if (subTheme.rating !== null) {
          // Le sous-thème est noté (rating >= 0) ou N/A (rating = -1)
          ratingDone++;
        }
      }

      // On en déduit le nb de sous-thèmes restés à l'état "à évaluer" (rating===null)
      var ratingNotDone = nbSubThemes - ratingDone;

      // On calcule le statut du thème (cf. SFD §3.73.6	- Écran « Liste des thèmes »)
      if (ratingDone == nbSubThemes && theme.globalRating.rating !== null) {
        // Le thème est traité ("complete") car :
        // - tous les sous-thèmes sont évalués (= marqué « Non concerné » OU possède une cotation)
        // ET
        // - une cotation globale du thème est définie
        this.completed = true;
        this.themeStatusTitle = this.$i18n.t("views.themeListView.themeState.completed");
      } else if (
        ratingNotDone == nbSubThemes &&
        theme.globalRating.rating === null
      ) {
        // Le thème est "vide" si tous les sous-thèmes sont non évalués et qu'il n'y pas d'évaluation globale
        this.empty = true;
      /* } else if (
        ratingDone === nbSubThemes &&
        theme.globalRating.rating === null
      ) {
        // Le thème n'est "pas applicable" si tous les sous-thèmes sont évalués et qu'il n'y pas d'évaluation globale
        theme.status = "notApplicable"; */
      } else {
        // Sinon le thème est "incomplet"
        this.inProgress = true;
        this.themeStatusTitle = this.$i18n.t("views.themeListView.themeState.inProgress");
      }      
    }    
  }
};
</script>


<style lang="sass" scoped>
@import "../../sass/_variables.sass"
@import "../../sass/_media.sass"

.themeCard
  position: relative
  color: white
  width: 155px
  height: 155px
  border-radius: 50%
  text-align: center
  cursor: pointer

  &.absolutePosition
    position: absolute

  &.complete
    background: linear-gradient(to bottom, $darkgray-0 0%, $darkgray-0 30%, $gray-4 30%, $gray-4 100%)

    &:hover, &:focus
      background: linear-gradient(to bottom, scale-color($darkgray-0, $lightness: -10%) 0%, scale-color($darkgray-0, $lightness: -10%) 30%, scale-color($gray-4, $lightness: -10%) 30%, scale-color($gray-4, $lightness: -10%) 100%)

  &.inProgress
    background: linear-gradient(to bottom, $darkgray-3 0%, $darkgray-3 30%, $gray-4 30%, $gray-4 100%)

    &:hover, &:focus
      background: linear-gradient(to bottom, scale-color($darkgray-3, $lightness: -10%) 0%, scale-color($darkgray-3, $lightness: -10%) 30%, scale-color($gray-4, $lightness: -10%) 30%, scale-color($gray-4, $lightness: -10%) 100%)

  &.empty
    background: linear-gradient(to bottom, $gray-3 0%, $gray-3 30%, $gray-4 30%, $gray-4 100%)

    &:hover, &:focus
      background: linear-gradient(to bottom, scale-color($gray-3, $lightness: -10%) 0%, scale-color($gray-3, $lightness: -10%) 30%, scale-color($gray-4, $lightness: -10%) 30%, scale-color($gray-4, $lightness: -10%) 100%)

  &.button
    border: 1px solid $gray-3
    color: $gray-3
    font-size: 1.1em
    width: 152px
    height: 152px
    background: linear-gradient(to bottom, $lightgray-4 0%, $lightgray-4 25%, $gray-3 26.33%, #fff 26.33%, #fff 100%)

    &:hover, &:focus
      background: linear-gradient(to bottom, scale-color($lightgray-4, $lightness: -10%) 0%, scale-color($lightgray-4, $lightness: -10%) 25%, scale-color($gray-3, $lightness: -10%) 26.33%, scale-color(#fff, $lightness: -5%) 26.33%, scale-color(#fff, $lightness: -5%) 100%)

  .themeCardHeader
    height: 45px

    &.abbr
      padding-top: 22px
      font-size: 1em

    &.addIcon
      position: relative
      font-size: 1.4em
      font-weight: bold

      .material-design-icon
        position: absolute
        top: 19px
        left: 50%
        transform: translate(-50%, -50%)
        line-height: 0

        ::v-deep svg
          display: block

  .content
    margin-top: 5px
    height: 100px
    font-size: 0.9em
    word-break: break-word
    overflow-wrap: break-word
    hyphens: auto

    @include ieOnly    
      padding:0 10px

    @include edgeOnly
      padding:0 10px


  .leftShape
    float: left
    width: 77.5px
    height: 155px
    //background: rgb(255,0,0,0.2)
    @include ieOnly
      display: none
    @include edgeOnly
      display: none

  .rightShape
    float: right
    width: 77.5px
    height: 155px
    //background: rgb(0,0,255,0.2)
    @include ieOnly    
      display: none
    @include edgeOnly
      display: none

.picto
  display: flex
  justify-content: center
  align-content: stretch
  align-items: center
  position: absolute
  background-color: white
  border-radius: 50%
  top: -1.15em
  right: 50%
  margin-right:-1.15em
  font-size: 0.9em
  width: 2.3em
  height: 2.3em
  
  &.completedIcon
    color: $darkgray-0
    border: 2px solid $darkgray-0

  &.inProgressIcon
    color: $darkgray-3
    border: 2px solid $darkgray-3

  .material-design-icon
    margin: 0.2em 0 0 0.1em
    @include ieOnly
      margin: 2px 0 0 2px

</style>

